// Single source of truth for the password policy.
// To change the policy: edit the constants / add or remove an entry in PASSWORD_RULES.
// Every screen that imports this (change password, reset, signup...) updates automatically.

export const MIN_LENGTH = 6;
export const ALLOWED_SYMBOLS = '@#$%'; // change to e.g. '@#$%!&*' when policy changes

const escapeForRegex = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const PASSWORD_RULES = [
  {
    id: 'length',
    label: `At least ${MIN_LENGTH} characters`,
    test: (pw) => pw.length >= MIN_LENGTH,
  },
  {
    id: 'uppercase',
    label: 'At least 1 uppercase letter',
    test: (pw) => /[A-Z]/.test(pw),
  },
  {
    id: 'symbol',
    label: `At least 1 symbol (${ALLOWED_SYMBOLS.split('').join(' ')})`,
    test: (pw) => new RegExp(`[${escapeForRegex(ALLOWED_SYMBOLS)}]`).test(pw),
  },
  {
    id: 'number',
    label: 'At least 1 number',
    test: (pw) => /\d/.test(pw),
  },
];

// Returns each rule with a `passed` flag for the given password.
export const checkPasswordPolicy = (password = '') =>
  PASSWORD_RULES.map((rule) => ({ ...rule, passed: rule.test(password) }));

export const isPasswordPolicyMet = (password = '') =>
  PASSWORD_RULES.every((rule) => rule.test(password));
